export function setSuppliesTable () {
  const suppliesTableCols = [
    {
      title: '商品图片',
      dataIndex: 'image',
      width: 120,
      ellipsis: true,
      scopedSlots: { customRender: 'imageList' },
    },
    {
      title: '商品编码（sku）',
      dataIndex: 'goodsCode',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '规格',
      dataIndex: 'specification',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '所属品牌',
      dataIndex: 'brandName',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '计量单位',
      dataIndex: 'unitOfMsment',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '销售数量',
      dataIndex: 'orderNum',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '销售单价（含税）',
      dataIndex: 'unitPrice',
      customRender: text => {
        return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
      },
    },
    {
      title: '生产商',
      dataIndex: 'producer',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '厂家编码',
      dataIndex: 'factoryCode',
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '保修期',
      dataIndex: 'period',
      customRender: (text, row) => {
        let ret = '--';

        if (text || text === 0) {
          ret = `${text}${row.periodUnit}`;
        }

        return ret;
      },
    },
    {
      title: '是否医疗件',
      dataIndex: 'isMedichair',
      customRender: text => {
        return text === 1 ? '是' : '否';
      },
    },
    {
      title: '产品注册证/备案凭证',
      dataIndex: 'regNo',
      customRender: text => {
        return text || '--';
      },
    },
  ];

  return suppliesTableCols;
}
